

























































































































import { Component, Mixins } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import { Sync } from '@/interfaces/Sync'
import axios from 'axios'
import SnackbarService from '@/services/snackbar-service'
import moment from 'moment-timezone'
import AuthService from '@/services/auth-service'
import { Cow } from '@/interfaces/Cow'

@Component({
  components: {},
})
export default class SettingsItems extends Mixins(
  DexieService,
  SnackbarService,
  AuthService
) {
  settings = ['farms', 'irons', 'races']
  editListDialogIsOpen = false
  editDetailsDialogIsOpen = false
  editDetailsDeleteDialogIsOpen = false
  settingType = ''
  newSettingValue = ''
  updateSettingValue = ''
  settingValeToUpdate = ''
  upateSettingId = 0
  deleteAlternativeId = ''
  openListEditDialog(setting: string) {
    this.editListDialogIsOpen = true
    this.settingType = setting
    console.log(setting)
  }
  hasCows = true

  created() {
    axios.get(`/cows-all`).then(res => {
      this.hasCows = res.data.length > 0
    })
  }

  postSetting() {
    const payload = { name: this.newSettingValue }
    axios.post(this.settingType, payload).then((res: any) => {
      this.updateAccount()
      this.newSettingValue = ''
      this.notify({ text: 'Added successfully', type: 'success' })
    })
  }

  openDetailsEditSettings(settingItem: any) {
    this.setSettingItem(settingItem)
    this.editDetailsDialogIsOpen = true
  }

  openDetailsDeleteSettings(settingItem: any) {
    this.deleteAlternativeId = ''
    this.setSettingItem(settingItem)
    this.editDetailsDeleteDialogIsOpen = true
  }

  setSettingItem(settingItem: any) {
    this.updateSettingValue = settingItem.name
    this.settingValeToUpdate = settingItem.name
    this.upateSettingId = settingItem.id
  }

  updateSetting() {
    const payload = { name: this.updateSettingValue }
    axios
      .patch(`${this.settingType}/${this.upateSettingId}`, payload)
      .then((res: any) => {
        this.updateAccount()
        this.editDetailsDialogIsOpen = false
        this.editDetailsDeleteDialogIsOpen = false
        this.notify({ text: 'Updated successfully', type: 'success' })
      })
  }

  deleteSetting() {
    if (this.deleteAlternativeId === '') {
      this.deleteAlternativeId = '-1'
    }
    axios
      .delete(`${this.settingType}/${this.upateSettingId}/${this.deleteAlternativeId}`)
      .then((res: any) => {
        this.updateAccount()
        this.editDetailsDialogIsOpen = false
        this.editDetailsDeleteDialogIsOpen = false
        this.notify({ text: 'Deleted successfully', type: 'success' })
      })
  }

  setDefault(settingItem: any) {
    console.log(this.settingType)
    console.log(settingItem)
    axios
      .post(`/col-default/${this.settingType}/${settingItem.id}`)
      .then(() => {
        this.updateAccount()
      })
  }

  get settingTypes() {
    if (!this.$store.state.account[this.settingType]) {
      return []
    }
    return this.$store.state.account[this.settingType].sort((i1, i2) =>
      i1.name.toLowerCase() < i2.name.toLowerCase() ? -1 : 1
    )
  }

  get alreadyExistsErrorAdd() {
    if (!this.$store.state.account || !this.newSettingValue) {
      return false
    }
    return this.$store.state.account[this.settingType]
      .map(i => i.name)
      .includes(this.newSettingValue)
  }

  get alreadyExistsMessageAdd() {
    return this.alreadyExistsErrorAdd ? 'Already exists' : ''
  }

  get alreadyExistsErrorUpdate() {
    if (!this.$store.state.account || !this.updateSettingValue) {
      return false
    }
    return this.$store.state.account[this.settingType]
      .map(i => i.name)
      .filter(n => n !== this.settingValeToUpdate)
      .includes(this.updateSettingValue)
  }

  get alreadyExistsMessageUpdate() {
    return this.alreadyExistsErrorUpdate ? 'Already exists' : ''
  }
}
